export default {
      id: "arrow-right-usage",
      viewBox: "0 0 40 74",
      url: __webpack_public_path__ + "img/icons.c3436384.svg#arrow-right",
      toString: function () {
        return this.url;
      }
    }